import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../../config/app';

type ConsentValue = 'accepted' | 'refused';
const STORAGE_KEY = 'cookie-consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(() =>
    typeof window !== 'undefined' && !localStorage.getItem(STORAGE_KEY)
  );

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as ConsentValue | null;
    if (stored && typeof window.gtag === 'function') {
      // Restore consent state on returning visits
      const granted = stored === 'accepted' ? 'granted' : 'denied';
      window.gtag('consent', 'update', {
        'ad_storage':              granted,
        'ad_user_data':            granted,
        'ad_personalization':      granted,
        'analytics_storage':       granted,
        'functionality_storage':   granted,
        'personalization_storage': granted,
      });
    }
  }, []);

  const handleChoice = (value: ConsentValue) => {
    localStorage.setItem(STORAGE_KEY, value);

    if (typeof window.gtag === 'function') {
      if (value === 'accepted') {
        window.gtag('consent', 'update', {
          'ad_storage':              'granted',
          'ad_user_data':            'granted',
          'ad_personalization':      'granted',
          'analytics_storage':       'granted',
          'functionality_storage':   'granted',
          'personalization_storage': 'granted',
        });
      } else {
        window.gtag('consent', 'update', {
          'ad_storage':              'denied',
          'ad_user_data':            'denied',
          'ad_personalization':      'denied',
          'analytics_storage':       'denied',
          'functionality_storage':   'denied',
          'personalization_storage': 'denied',
        });
      }
    }

    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-surface/95 backdrop-blur-md border-t border-line"
        >
          <div className="container-site py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="flex-1 text-sm text-fg-muted leading-relaxed">
              Ce site utilise des cookies{' '}
              <span className="text-fg font-medium">fonctionnels</span> (nécessaires au bon
              fonctionnement du site) et des cookies{' '}
              <span className="text-fg font-medium">analytiques</span> (pour mesurer
              l'audience) avec votre consentement.{' '}
              <Link
                to={APP_CONFIG.routes.politiqueConfidentialite}
                className="text-accent-soft hover:underline whitespace-nowrap"
              >
                En savoir plus
              </Link>
            </p>
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                type="button"
                onClick={() => handleChoice('refused')}
                className="btn-secondary !px-5 !py-2 !text-sm"
              >
                Refuser
              </button>
              <button
                type="button"
                onClick={() => handleChoice('accepted')}
                className="btn-primary !px-5 !py-2 !text-sm"
              >
                Tout accepter
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
